import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestsService } from 'src/app/services/requests.service';

@Component({
  selector: 'app-sri-details',
  templateUrl: './sri-details.component.html',
  styleUrls: ['./sri-details.component.scss']
})
export class SriDetailsComponent implements OnInit {
  dsriData: any;
  isLoading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pilotData: any,
    private requestsService: RequestsService,
    private dialogRef: MatDialogRef<SriDetailsComponent>
  ) {}

  ngOnInit(): void {
    this.requestsService.getAllDsriData().subscribe(data => {
      this.dsriData = data;
      this.isLoading = false;
    });
  }

  getComparisonValueForDomain(key: string): string {
    return this.dsriData?.['Smartness Scores']?.['Domains']?.[0]?.[key] || 'N/A';
  }

  getComparisonValueForImpact(key: string): string {
    return this.dsriData?.['Smartness Scores']?.['Impact_criteria']?.[0]?.[key] || 'N/A';
  }

  getTotalSRIComparison(): string {
    return this.dsriData?.['Smartness Scores']?.['Total_SRI_Score'] || 'N/A';
  }

  close() {
    this.dialogRef.close();
  }
}
